import api from "../api";
import type { ApiResponse, Hotel } from "@/types";

export const hotelApi = {
    create: (params?: any) => api.post('admin/hotels', params),

    getAll: () => api.get<ApiResponse<Hotel[]>>("admin/hotels"),

    getAllPublic: () => api.get<ApiResponse<Hotel[]>>("hotels"),

    show: (id: number) => api.get<ApiResponse<Hotel>>(`hotels/${id}`),

    update: (id: number, params?: any) => api.post(`admin/hotels/${id}`, params),

    delete: (id: number) => api.delete(`admin/hotels/${id}`),
    
    replaceSecondaryLogo: (formData: FormData) => api.post<{ new_path: string }>(`admin/hotels/change-logo`, formData),

    replaceSecondaryMainImage: (formData: FormData) => api.post<{ new_path: string }>(`admin/hotels/change-image`, formData),

    replaceSecondaryImages: (formData: FormData) => api.post<{ new_path: string }>(`admin/hotels/change-images`, formData),

    deleteimageByImages: (hotelId: number, params?: any) => api.deleteWithBody(`admin/hotels/${hotelId}/images`, params)
}